import BaseApi from "./baseApi";

class ProgramApi extends BaseApi {
  async getAllRoastersInfo(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/program/getAllRoastersInfo",
      data: data,
      method: "post",
    });
  }

  async getProgramDetail(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/program/getProgramDetail",
      data: data,
      method: "post",
    });
  }

  async removeProgramImage(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/program/removeProgramImage",
      data: data,
      method: "post",
    });
  }

  async createProgram(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/program/createProgram",
      data: data,
      method: "post",
    });
  }

  async updateEndingPageBgColor(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/program/updateEndingPageBgColor",
      data,
      method: "post",
    });
  }

  async removeProgramFooterImage(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/program/removeProgramFooterImage",
      data: data,
      method: "post",
    });
  }

  async changePublishStatus(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/program/changePublishStatus",
      data: data,
      method: "post",
    });
  }

  async createRetreatTeam(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/program/createRetreatTeam",
      data: data,
      method: "post",
    });
  }

  async deleteRoasterCouple(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/program/deleteRoasterCouple",
      data: data,
      method: "post",
    });
  }
}

export default ProgramApi;
